export enum SensorState {
  RED = 'red',
  GREEN = 'green',
  YELLOW = 'yellow',
}
